// TypeScriptファイル内でexportを利用していない場合は、export{};を定義
export {};

// 拡張メソッドの定義
declare global {
    interface Date {
        /**
         * @brief   日付時分の比較結果を返します
         * @return	1	this > in_time
	     * @return	0	this = in_time
	     * @return	-1	this < in_time
         */
        CompareSystemTimeDateHourMinute(in_time: Date): number;

        /**
         * @brief   日付の比較結果を返します
         * @return	1	this > in_time
         * @return	0	this = in_time
         * @return	-1	this < in_time
         */
        CompareSystemTimeDate(in_time: Date): number;

        /**
         * @brief「yyyy/mm/dd hh:mm:ss」形式の文字列に変換
         * @return 「yyyy/mm/dd hh:mm:ss」形式の日付文字列
         */
        SystemtimeToStr(): string;

        /**
         * @brief「yyyymmddhhmmss」形式の文字列に変換
         * @return 「yyyymmddhhmmss」形式の日付文字列
         */
        SystemtimeToStr3(): string;

        /**
         * @brief「yyyy/mm/dd hh:mm」形式の文字列に変換
         * @return 「yyyy/mm/dd hh:mm」形式の日付文字列
         */
        SystemtimeToStr7(): string;

        /**
         * @brief「yyyy/mm/dd hh:mm」形式の文字列に変換(UTC版)
         * @return 「yyyy/mm/dd hh:mm」形式の日付文字列
         */
        SystemtimeToStr7UTC(): string;

        /**
         * @brief「yyyy-MM-ddThh:mm:ss」形式の文字列に変換
         * @return 「yyyy-MM-ddThh:mm:ss」形式の日付文字列
         */
        SystemtimeToStr10(): string;

        /**
         * @brief「yyyy/mm/dd」形式の文字列に変換
         * @return 「yyyy/mm/dd」形式の日付文字列
         */
        SystemtimeToDateStr(): string;

        /**
         * @brief「YYYY年MM月DD日hh時mm分」形式の文字列に変換
         * @return 「YYYY年MM月DD日hh時mm分」形式の日付文字列
         */
        SystemtimeToStr30(): string;

        /**
         * 月の加減算を行います。
         * @param	nAmount		[in]	月に追加される日付または時刻の量
         */
        AddMonth(nAmount: number): void;

        /**
         * UTCからローカル時間に変換します
         */
        UtcToLocalTime(): Date;
    }
}

// 拡張メソッドの実装

/**
 * @brief   日付時分の比較結果を返します
 * @return	1	this > in_time
 * @return	0	this = in_time
 * @return	-1	this < in_time
 */
Date.prototype.CompareSystemTimeDateHourMinute = function (in_time: Date) {
    if (this.getFullYear() < in_time.getFullYear()) return -1;
    if (this.getFullYear() > in_time.getFullYear()) return 1;
    if (this.getMonth() < in_time.getMonth()) return -1;
    if (this.getMonth() > in_time.getMonth()) return 1;
    if (this.getDate() < in_time.getDate()) return -1;
    if (this.getDate() > in_time.getDate()) return 1;
    if (this.getHours() < in_time.getHours()) return -1;
    if (this.getHours() > in_time.getHours()) return 1;
    if (this.getMinutes() < in_time.getMinutes()) return -1;
    if (this.getMinutes() > in_time.getMinutes()) return 1;
    return 0;
};

/**
 * @brief   日付の比較結果を返します
 * @return	1	this > in_time
 * @return	0	this = in_time
 * @return	-1	this < in_time
 */
Date.prototype.CompareSystemTimeDate = function (in_time: Date) {
    if (this.getFullYear() < in_time.getFullYear()) return -1;
    if (this.getFullYear() > in_time.getFullYear()) return 1;
    if (this.getMonth() < in_time.getMonth()) return -1;
    if (this.getMonth() > in_time.getMonth()) return 1;
    if (this.getDate() < in_time.getDate()) return -1;
    if (this.getDate() > in_time.getDate()) return 1;
    return 0;
};

/**
 * @brief「yyyy/mm/dd hh:mm:ss」形式の文字列に変換
 * @return 「yyyy/mm/dd hh:mm:ss」形式の日付文字列
 */
Date.prototype.SystemtimeToStr = function () {
    const day: number = this.getDate();
    const month: number = this.getMonth() + 1;
    const year: number = this.getFullYear();
    const hour: number = this.getHours();
    const minute: number = this.getMinutes();
    const seconds: number = this.getSeconds();
    return year.toString() + '/' + ('00' + month).slice(-2) + '/' + ('00' + day).slice(-2) + ' ' + ('00' + hour).slice(-2) + ':' + ('00' + minute).slice(-2) + ':' + ('00' + seconds).slice(-2);
};

/**
 * @brief「yyyymmddhhmmss」形式の文字列に変換
 * @return 「yyyymmddhhmmss」形式の日付文字列
 */
Date.prototype.SystemtimeToStr3 = function () {
    const day: number = this.getDate();
    const month: number = this.getMonth() + 1;
    const year: number = this.getFullYear();
    const hour: number = this.getHours();
    const minute: number = this.getMinutes();
    const seconds: number = this.getSeconds();
    return year.toString() + ('00' + month).slice(-2) + ('00' + day).slice(-2) + ('00' + hour).slice(-2) + ('00' + minute).slice(-2) + ('00' + seconds).slice(-2);
};

/**
 * @brief「yyyy/mm/dd hh:mm」形式の文字列に変換
 * @return 「yyyy/mm/dd hh:mm」形式の日付文字列
 */
Date.prototype.SystemtimeToStr7 = function () {
    const day: number = this.getDate();
    const month: number = this.getMonth() + 1;
    const year: number = this.getFullYear();
    const hour: number = this.getHours();
    const minute: number = this.getMinutes();
    return year.toString() + '/' + ('00' + month).slice(-2) + '/' + ('00' + day).slice(-2) + ' ' + ('00' + hour).slice(-2) + ':' + ('00' + minute).slice(-2);
};

/**
 * @brief「yyyy/mm/dd hh:mm」形式の文字列に変換(UTC版)
 * @return 「yyyy/mm/dd hh:mm」形式の日付文字列
 */
Date.prototype.SystemtimeToStr7UTC = function () {
    const day: number = this.getUTCDate();
    const month: number = this.getUTCMonth() + 1;
    const year: number = this.getUTCFullYear();
    const hour: number = this.getUTCHours();
    const minute: number = this.getUTCMinutes();
    return year.toString() + '/' + ('00' + month).slice(-2) + '/' + ('00' + day).slice(-2) + ' ' + ('00' + hour).slice(-2) + ':' + ('00' + minute).slice(-2);
};

/**
 * @brief「yyyy-MM-ddThh:mm:ss」形式の文字列に変換
 * @return 「yyyy-MM-ddThh:mm:ss」形式の日付文字列
 */
Date.prototype.SystemtimeToStr10 = function () {
    const day: number = this.getDate();
    const month: number = this.getMonth() + 1;
    const year: number = this.getFullYear();
    const hour: number = this.getHours();
    const minute: number = this.getMinutes();
    const seconds: number = this.getSeconds();
    return year.toString() + '-' + ('00' + month).slice(-2) + '-' + ('00' + day).slice(-2) + 'T' + ('00' + hour).slice(-2) + ':' + ('00' + minute).slice(-2) + ':' + ('00' + seconds).slice(-2);
};

/**
 * @brief「yyyy/mm/dd」形式の文字列に変換
 * @return 「yyyy/mm/dd」形式の日付文字列
 */
Date.prototype.SystemtimeToDateStr = function () {
    const day: number = this.getDate();
    const month: number = this.getMonth() + 1;
    const year: number = this.getFullYear();
    return `${year}/${('00' + month).slice(-2)}/${('00' + day).slice(-2)}`;
};

/**
 * @brief「YYYY年MM月DD日hh時mm分」形式の文字列に変換
 * @return 「YYYY年MM月DD日hh時mm分」形式の日付文字列
 */
Date.prototype.SystemtimeToStr30 = function () {
    const day: number = this.getDate();
    const month: number = this.getMonth() + 1;
    const year: number = this.getFullYear();
    const hour: number = this.getHours();
    const minute: number = this.getMinutes();
    return year.toString() + '年' + month.toString() + '月' + day.toString() + '日' + hour.toString() + '時' + minute.toString() + '分';
};

/**
 * 月の加減算を行います。
 * @param	nAmount		[in]	月に追加される日付または時刻の量
 */
Date.prototype.AddMonth = function (nAmount: number) {
    const oldDate = new Date(this);

    // 加減算
    this.setMonth(this.getMonth() + nAmount);

    // 日付が変わっていたら、月の最終日だった可能性がある
    if (oldDate.getDate() != this.getDate()) {
        // -1か月して、末日をセット
        this.setMonth(this.getMonth() - 1);

        // これで月の最終日が求められる(うるう年込み)
        const endDate = new Date(this.getFullYear(), this.getMonth() + 1, 0);

        this.setDate(endDate.getDate());
    }
}

/**
* UTCからローカル時間に変換します
*/
Date.prototype.UtcToLocalTime = function () {
    // 実行環境とUTCとの差分（単位：時間）を取得
    const timezoneOffset = new Date().getTimezoneOffset() + (9 * 60) * 60 * 1000;
    const localTime = new Date(this.getTime() + timezoneOffset)
    return localTime;
};
